import React from 'react';
import Dropzone from 'react-dropzone';
import {
  Modal,
  Col,
  Row,
} from 'react-bootstrap';
import {
  FormControl,
  Button,
} from '../../../form/FormControls.jsx';
import Label from '@/component/form/Label.jsx';
import { connect } from 'react-redux';
import { addFile } from '../store/files.store';
import { handleFormChanged } from '@/store/allaround.store.js';

class UploadZone extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onSave = this.onSave.bind(this);
    this.changeRegNumber = this.onChange.bind(this, 'regNumber');
    this.addFile = this.addFile.bind(this);
    this.state = {
      currentFile: undefined,
      meta: {},
    };
  }

  onDrop(files) {
    this.setState({ currentFile: files[0], meta: {} });
  }

  onSave() {
    if (this.state.currentFile) {
      const newMeta = Object.assign({ type: this.props.type }, this.state.meta);
      this.addFile({ file: this.state.currentFile, meta: newMeta });
      this.setState({
        currentFile: undefined,
        meta: {},
      });
      this.props.onClose();
    }
    this.props.handleFormChanged();
  }

  onChange(field, evt) {
    this.setState({ meta: { [field]: evt.target.value } });
  }

  getLabel(f) {
    let label = '';
    if (f.meta && f.meta.originalName) {
      label = f.meta.originalName;
    } else if (f.file && f.file.name) {
      label = f.file.name;
    } else {
      label = f.name;
    }
    return label;
  }

  getLabelList(f) {
    const regNumber = f.meta && f.meta.regNumber ? f.meta.regNumber : undefined;
    const fileName = f.meta && f.meta.originalName ? f.meta.originalName : f.file.name;
    return (<div>
      <div style={{ wordBreak: 'break-all' }}>
        {regNumber}
      </div>
      <div
        style={regNumber ? { fontSize: 'x-small', wordBreak: 'break-all' }
          : { wordBreak: 'break-all' }}
      >
        {fileName}
      </div>
    </div>);
  }

  addFile(files) {
    if (this.props.onAddFile) {
      this.props.onAddFile(files);
    }
    this.props.addFile(files);
  }

  close() {
    this.props.onClose();
    this.setState({ currentFile: undefined, meta: undefined });
  }

  formEditModal(key) {
    return (
      <div key={key}>
        <Col key={key} md={12} style={{ padding: '10px 0 0 0' }}>
          <Label label="Document name" xs={4}>
            <FormControl
              name="regNumber" id="regNumber" defaultValue={this.state.meta.regNumber}
              onChange={this.changeRegNumber}
            />
          </Label>
        </Col>
      </div>
    );
  }

  render() {
    const currentFileDiv = [];
    let label = '';
    if (this.state.currentFile) {
      currentFileDiv.push(this.formEditModal('currentFile'));
      label = this.getLabel(this.state.currentFile);
    }

    return (
      <div>
        <Modal show={this.props.showModal} onHide={this.close} >
          <Modal.Body style={{ paddingBottom: '10px' }}>
            <Row>
              <Col md={12}><h4>{label}</h4></Col>
            </Row>
            <Row>
              {this.state.editMode ? '' :
                <Col md={12}>
                  <Dropzone
                    style={{ width: '100%', height: '6em', border: '1px dashed lightgrey',
                      color: 'lightgray', display: 'flex', justifyContent: 'center',
                      cursor: 'pointer' }}
                    id="files" name="files" onDrop={this.onDrop} multiple={false}
                  >
                    <span style={{ alignSelf: 'center' }}>Click or drop here to add file</span>
                  </Dropzone>
                </Col>
              }
              {currentFileDiv}
            </Row>
          </Modal.Body>
          <Modal.Footer style={{ paddingTop: 0, border: 'none' }}>
            <Button id="close_file" style={{ width: 71 }} onClick={this.close}>Cancel</Button>
            <Button
              id="add_file" style={{ width: 71 }} bsStyle="primary" onClick={this.onSave}
            >
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

UploadZone.propTypes = {
  files: React.PropTypes.object,
  label: React.PropTypes.string,
  type: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  addFile: React.PropTypes.func,
  handleFormChanged: React.PropTypes.func,
  showModal: React.PropTypes.bool,
  onAddFile: React.PropTypes.func,
  onClose: React.PropTypes.func,
};

export default connect(
  (state, props) => ({
    files: state.getIn(['data', 'deals', 'files', props.type]),
  }),
  (dispatch, props) => ({
    addFile(files) {
      addFile(dispatch, files, props.type);
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  })
)(UploadZone);
